import React from 'react';
import { useTranslations } from 'next-intl';

import FilterModal from './filter-modal';
import SearchInput from './search-input';
import SortsSelect from './sorts-select';

const FilterCourse = () => {
  const t = useTranslations();

  return (
    <div className="mb-8 mt-5">
      <h1 className="text-xl font-semibold">{t('barcha_kurslar_royxati')}</h1>
      <div className="mt-3 flex flex-row justify-between gap-2 sm:flex-col lg:flex-row lg:items-center">
        <div className="sm:flex-0 flex-1">
          <SearchInput />
        </div>

        <div className="hidden items-center gap-3 sm:flex">
          <SortsSelect selectClassName='!max-w-40 !py-2' />
        </div>
        <FilterModal />
      </div>
    </div>
  );
};

export default FilterCourse;
